<!--
component: MapPane
author: Ken Nakamura
description: 地図検索画面
-->
<template>
  <section class="towns">
    <div id="towns-pane-legacy">
      <div class="head-message">
        町名を選択して下さい
        <!--<v-spacer />-->
        <v-progress-circular v-show="loading"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <!-- 町情報ローディング中の進捗バー -->
      <v-progress-linear
        color="deep-purple accent-4"
        rounded
        height="6"
        :active="loading"
        :indeterminate="loading"
        absolute
      ></v-progress-linear>
      <!-- 頭文字別に町名ボタンが 配置されるタブシート -->
      <v-tabs :vertical="verticalTabs" v-model="activeTab">
        <v-tab href="#tab-a" class=ges-town-tab>あ行</v-tab>
        <v-tab href="#tab-k" class=ges-town-tab>か行</v-tab>
        <v-tab href="#tab-s" class=ges-town-tab>さ行</v-tab>
        <v-tab href="#tab-t" class=ges-town-tab>た行</v-tab>
        <v-tab href="#tab-n" class=ges-town-tab>な行</v-tab>
        <v-tab href="#tab-h" class=ges-town-tab>は行</v-tab>
        <v-tab href="#tab-m" class=ges-town-tab>ま行</v-tab>
        <v-tab href="#tab-y" class=ges-town-tab>や行</v-tab>
        <v-tab href="#tab-r" class=ges-town-tab>ら行</v-tab>
        <v-tab href="#tab-w" class=ges-town-tab>わ行</v-tab>
        <v-tab-item value="tab-a" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsA" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ?
                    "grey darken-1 grey--text text--lighten-1" :
                    "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-k" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsK" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-s" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsS" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-t" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsT" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-n" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsN" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-h" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsH" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-m" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsM" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-y" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsY" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-r" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsR" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item value="tab-w" class="ges-town-tabpanel">
          <v-container fluid>
            <v-row>
              <v-flex xl2 lg2 md3 sm4 xs6 v-for="(town, index) in TownsW" :key="index">
                <v-btn @click="jumpTown(town)" width="95%"
                  class="text-sm-h5 my-2 py-7 mx-2"
                  :class='[town.oldFlag ? "grey darken-1 grey--text text--lighten-1" : "green lighten-4 green--text text--darken-4"]'>
                  {{town.name}}
                </v-btn>
              </v-flex>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
      <Dialog error :open="error" :ok="()=>error=false" to="/"
        :title="errorTitle" :body="errorMessage" />
    </div>
  </section>
</template>

<script>
import router from '../router'
import store from '../store'
import { dbglog } from '../common/utils.js'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'

export default {
  components: {
    Dialog,
  },
  data: () => ({
    tokenDispired: false,
    verticalTabs: false,
    TownsA: [],
    TownsK: [],
    TownsS: [],
    TownsT: [],
    TownsN: [],
    TownsH: [],
    TownsM: [],
    TownsY: [],
    TownsR: [],
    TownsW: [],
    activeTab: '',
    loading: false,
    error: false,
    errorTitle: 'エラー',
    errorMessage: '',
  }),
  props: {
    ward: {
      type: Number,
      default: 0,
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.errorTitle = 'ユーザー認証エラー';
      this.errorMessage = 'ユーザが無効です。ログインし直して下さい。';
      this.error = true;
    }
    this.$store.commit('setCurrentPage', 3);
    dbglog('Towns.mounted: wardCode=' + this.wardCode + ', wardName=' + this.wardName);
    if (this.ward != 0) {
      this.$store.commit('setWardCode', this.ward);
    }
    this.message = `地名・地番検索：${this.wardName}`;
    this.loadTowns();

    this.$store.commit('setChibanOya', 0);
    this.$store.commit('setChibanEda', 0);

    this.activeTab = this.$store.state.townTab;
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined
       || this.token == null
       || this.token.length == 0
       || this.tokenDispired;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    mode () {
      return this.$store.state.mode;
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townsUrl() {
      if (this.mode == 1) {
        return this.$store.state.apiOrigin + 'api/AllTowns';
      }
      // 昇降機も廃町を表示する
      else if (this.mode == 2) {
        return this.$store.state.apiOrigin + 'api/AllTowns';
      }
      //
      else {
        return this.$store.state.apiOrigin + 'api/Towns';
      }
    },
    includeOldTowns () {
      return this.$store.state.includeOldTowns;
    },
  },
  methods: {
    /**
     * 選択された町情報を登録して地番検索画面に進む
     */
    jumpTown(town) {
      store.commit('setTown', { code: town.code, name: town.name });
      store.commit('setTownTab', this.activeTab);
      // 地図検索のために町中心座標をセット
      store.commit('setCenter', { x:town.x, y:town.y });
      dbglog(`${store.state.townCode}:${store.state.townName} (${store.state.centerx},${store.state.centery})`)
      router.push('kousakuaddress');
    },
    /**
     * APIから町情報を取得する
     */
    loadTowns () {
      this.loading = true;
      const url = this.townsUrl + '?ward=' + this.wardCode;
      callGetApi(url, (data) => {
        this.loading = false;
        if (data.errorCode !== undefined) {
          if (data.errorCode == 401) {
            //this.$router.replace('/');
            this.errorTitle = 'ユーザ認証エラー';
            this.errorMessage = 'ユーザが無効です。ログインし直して下さい。';
            this.error = true;
          }
          else {
            this.progressMessage = `エラー:${data.errorCode} ${data.errorDesc}`;
          }
        }
        else {
          this.initTownArray(data);
        }
      });
    },
    /**
     * 頭文字別に町情報を登録する
     */
    initTownArray(data) {
      for (let i = 0; i < data.length; i++) {
        let town = data[i];
        if (!this.includeOldTowns && town.oldFlag) {
          continue;
        }
        else if ((town.yomi >= 'ｱ' && town.yomi < 'ｶ') || (town.yomi >= 'あ' && town.yomi < 'か')) {
          this.TownsA.push(town);
        }
        else if ((town.yomi >= 'ｶ' && town.yomi < 'ｻ') || (town.yomi >= 'か' && town.yomi < 'さ')) {
          this.TownsK.push(town);
        }
        else if ((town.yomi >= 'ｻ' && town.yomi < 'ﾀ') || (town.yomi >= 'さ' && town.yomi < 'た')) {
          this.TownsS.push(town);
        }
        else if ((town.yomi >= 'ﾀ' && town.yomi < 'ﾅ') || (town.yomi >= 'た' && town.yomi < 'な')) {
          this.TownsT.push(town);
        }
        else if ((town.yomi >= 'ﾅ' && town.yomi < 'ﾊ') || (town.yomi >= 'な' && town.yomi < 'は')) {
          this.TownsN.push(town);
        }
        else if ((town.yomi >= 'ﾊ' && town.yomi < 'ﾏ') || (town.yomi >= 'は' && town.yomi < 'ま')) {
          this.TownsH.push(town);
        }
        else if ((town.yomi >= 'ﾏ' && town.yomi < 'ﾔ') || (town.yomi >= 'ま' && town.yomi < 'や')) {
          this.TownsM.push(town);
        }
        else if ((town.yomi >= 'ﾔ' && town.yomi < 'ﾗ') || (town.yomi >= 'や' && town.yomi < 'ら')) {
          this.TownsY.push(town);
        }
        else if ((town.yomi >= 'ﾗ' && town.yomi < 'ﾜ') || (town.yomi >= 'ら' && town.yomi < 'わ')) {
          this.TownsR.push(town);
        }
        else if ((town.yomi >= 'ﾜ' && town.yomi < 'ﾝ') || (town.yomi >= 'わ' && town.yomi < 'ん')) {
          this.TownsW.push(town);
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>

@import "../styles/common/common.css";

.towns {
  font-size: 24px;
}
.tab-content {
  padding-top: 0px;
}
#towns-pane-legacy {
  padding-bottom: 12px;
}
.ges-button {
  padding: 10px;
  /* border: 6px solid mediumturquoise; */
  font-size: calc(1.25rem + 4.0vw);
  font-weight: 300;
  text-anchor: middle;
  cursor: pointer;
  user-select: none;
  /*
  box-shadow: 3px 3px #555555;
  */
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2),
  0 25px 50px 0 rgba(0, 0, 0, 0.1);
  }
  .ges-button:active {
    box-shadow: 3px 3px white;
}
.ges-button:hover {
  color: yellow;
}

.ges-town-tab {
  font-size: calc(1.0rem + 1.1vw);
  font-weight: 400;
  margin: 0.3rem;
}

.ges-town-tabpanel {
  font-size: 1.8rem;
  font-weight: 400;
  margin: 0.3rem;
}

.ges-btn {
  border-radius: 5px;
  border: 0px;
  background-color: #aaddcc;
  margin: 10px 0px;
  padding: 10px;
  font-size: calc(1.2rem + 0.375vw);
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  color: #333355;
  cursor: pointer;
  user-select: none;
}
.ges-btn:hover {
  background-color: #0a3f46;
  color: white;
}
</style>